
function fixSlugs( url ){
    return url.toLowerCase().replace(/^\/?([^\/]+(?:\/[^\/]+)*)\/?$/, '/$1/');
}

export default fixSlugs;